import React from "react";
import siteConfig from "../config/siteConfig";
import "../css/privacy.scss";

function Privacy() {
  return (
    <main className="policy-page privacy" aria-labelledby="privacy-title">
      <header className="policy-page__intro">
        <div className="policy-page__intro-inner">
          <p className="policy-page__kicker">Customer care / Legal</p>
          <h1 id="privacy-title">Privacy policy</h1>
          <p className="policy-page__lead">
            This policy explains what information {siteConfig.brandName} collects,
            why we use it and the choices you have.
          </p>
          <p className="policy-page__updated">Last updated 15 August 2026</p>
        </div>
      </header>

      <div className="policy-page__layout">
        <nav className="policy-page__contents" aria-label="Privacy policy contents">
          <p>On this page</p>
          <a href="#privacy-collect">Information we collect</a>
          <a href="#privacy-use">How we use it</a>
          <a href="#privacy-cookies">Cookies</a>
          <a href="#privacy-share">Sharing and retention</a>
          <a href="#privacy-rights">Your rights</a>
          <a href="#privacy-contact">Contact us</a>
        </nav>

        <article className="policy-page__content">
          <section id="privacy-collect">
            <p className="policy-page__section-number">01</p>
            <h2>Information we collect</h2>
            <p>
              We collect information you provide when placing an order, creating
              an enquiry or signing up for updates. This can include your name,
              contact details, delivery and billing address, order history and
              messages to our customer care team.
            </p>
            <p>
              We also receive limited technical information, such as browser type,
              device information and pages visited, to keep the site reliable and
              understand how it is used.
            </p>
          </section>

          <section id="privacy-use">
            <p className="policy-page__section-number">02</p>
            <h2>How we use your information</h2>
            <ul>
              <li>Process, deliver and support your orders.</li>
              <li>Respond to questions about products, fit, care and returns.</li>
              <li>Prevent fraud and keep our services secure.</li>
              <li>Improve our products, website and customer experience.</li>
              <li>Send marketing only where you have asked us to do so.</li>
            </ul>
          </section>

          <section id="privacy-cookies">
            <p className="policy-page__section-number">03</p>
            <h2>Cookies and analytics</h2>
            <p>
              Essential cookies keep the basket and checkout working. Optional
              analytics and preference cookies help us measure performance and
              remember useful choices. You can restrict optional cookies through
              your browser settings, although some features may work differently.
            </p>
          </section>

          <section id="privacy-share">
            <p className="policy-page__section-number">04</p>
            <h2>Sharing and retention</h2>
            <p>
              We share only the information needed by trusted providers that help
              us operate the store, including payment, delivery, hosting and
              customer-support services. We do not sell personal information.
            </p>
            <p>
              Information is retained only for as long as needed to fulfil these
              purposes, meet legal obligations and resolve disputes, after which it
              is deleted or anonymised.
            </p>
          </section>

          <section id="privacy-rights">
            <p className="policy-page__section-number">05</p>
            <h2>Your rights</h2>
            <p>
              Depending on where you live, you may ask to access, correct, delete
              or restrict the use of your information, or object to certain uses.
              You can also withdraw marketing consent at any time.
            </p>
          </section>

          <section id="privacy-contact" className="policy-page__callout">
            <p className="policy-page__section-number">06</p>
            <h2>Questions about your data?</h2>
            <p>
              Contact our team at{" "}
              <a href={`mailto:${siteConfig.contact.email}`}>
                {siteConfig.contact.email}
              </a>
              . We will verify and respond to privacy requests as promptly as
              possible.
            </p>
          </section>
        </article>
      </div>
    </main>
  );
}

export default Privacy;
